import type { z } from "zod";

import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./index.css";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CatchBoundary, RouterProvider } from "@tanstack/react-router";

import type { AuthFormSchema } from "./lib/schema";
import type { Contract } from "./types/contract";
import type { Dispute } from "./types/dispute";
import type { Order } from "./types/order";
import type { BuyerRequest } from "./types/product-request";
import type { Product } from "./types/products";

import { router } from "./router";

// const router = createRouter({
// 	routeTree,
// 	defaultPreload: "intent"
// });

// if (!import.meta.env.DEV) {
Sentry.init({
	dsn: "https://693544ba72b9ef2dcfc28f51d4f6c715@o4509020207448069.ingest.de.sentry.io/4509037316603984",
	integrations: [
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false
		})
	],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0,

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
	// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["localhost", /^https:\/\/user\.dev\.intasida\.com\/api\//]
});
// }

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
	interface HistoryState {
		product?: Product;
		contract?: Contract;
		order?: Order;
		verifyEmailOpts?: {
			email: string;
			hash?: string;
		};
		request?: BuyerRequest;
		dispute?: Dispute;
		auth?: { data?: z.infer<ReturnType<typeof AuthFormSchema>>; isGoogleAuth: boolean };
	}
}

const queryClient = new QueryClient(
	// {
	// 	defaultOptions: {
	// 		queries: {
	// 			retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000)
	// 		}
	// 	}
	// }
);
const rootElement = document.getElementById("app")!;

// if (!rootElement.innerHTML) {
const root = ReactDOM.createRoot(rootElement);

root.render(
	<div id="app-content">
		<CatchBoundary
			getResetKey={() => "reset"}
			onCatch={error => console.error(error)}
		>
			<QueryClientProvider client={queryClient}>
				<RouterProvider router={router} />
				{import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
			</QueryClientProvider>
		</CatchBoundary>
	</div>
);
// }
